let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1eks3")).then(() => parcelRequire('69093'));